<template lang="html">
<!-- 提现详细 -->
<div v-if="pages.total_count > 0">
  <div class="">
    <b-table striped :items="LicensesData" :fields="fields4">
      <template slot="actualAmount" slot-scope="data">{{ data.item.amount }}</template>
      <template slot="PaymentChannels" slot-scope="data">{{ data.item.pay_type }}</template>
      <template slot="Pay_nickname" slot-scope="data">{{ data.item.pay_nickname }}</template>
      <template slot="Date" slot-scope="data">{{ data.item.ctime?data.item.ctime:"-" }}
      </template>
      <template slot="stateOfPayment" slot-scope="data">{{ data.item.state }}</template>
      <template slot="pay_fee" slot-scope="data">{{ data.item.pay_fee }}</template>
      <template slot="descr" slot-scope="data">
        <div class="memo" :title="data.item.memo">
          {{data.item.memo}}
        </div>
      </template>
    </b-table>
  </div>
  <b-pagination
   class="mt40"
   align="center"
   size="md"
   @input="getInfo"
   :total-rows="pages.total_count"
   v-if="pages.total_count>20"
   v-model="pages.page"
   :per-page="pages.count">
 </b-pagination>
</div>
<div class="tc pt20" v-else style="border-top: 1px solid #eee;">
  <div class="default">
    {{$t("Wallets.IncomeDefault")}}
  </div>
</div>
</template>

<script>
export default {
  data(){
    return{
      fields4:[//提现
        {
          key: "actualAmount",
          label: `${this.$t("transactionDetail.actualAmount")}`
        },
        { key: "PaymentChannels", label: `${this.$t("transactionDetail.channel")}`},// 通道
        { key: "Pay_nickname", label: `${this.$t("transactionDetail.Account")}`},// 账号
        {
          key: "Date",
          label: `${this.$t("transactionDetail.Date")}`
        },
        { key: "stateOfPayment", label: `${this.$t("transactionDetail.state")}`}, // 状态
        { key: "pay_fee", label: `${this.$t("transactionDetail.pay_fee")}`}, // 提现手续费

        // {
        //   key: "WithdrawalState",
        //   label: `${this.$t("transactionDetail.state")}`
        // },

        {
          key: "descr",
          label: `${this.$t("transactionDetail.descr")}`
        },
      ],
      LicensesData:[],
      pages:{
        "total_count": 0,
        "page": 1,
        "count": 20,
      },
    }
  },
  mounted(){
    this.detailInit(4,this.pages.page);
  },
  methods:{
    getInfo(){
      this.detailInit(4,this.pages.page);
      this.$router.push({name:"",params:{page: this.pages.page}});
    },
    detailInit(type,page){
      var _this = this;
      _this.$http.account({
        type:type,
        page:page,
        per_page:_this.pages.count,
      },(res)=>{
        if(res.ret == 200){
          _this.type = type;
          _this.LicensesData = res.data.data;
          _this.$set(_this.pages,"total_count",res.data.pages.total_count);
        }
      })
    },
  }
}
</script>

<style lang="scss">
</style>
